import { AppTheme } from "@/enums/Enums";
import { useTheme } from "@/store/selectors/AppSelectors";
import logoWhite from "@assets/images/logo-white.svg";
import logo from "@assets/images/logo.svg";
import clsx from "clsx";

interface LoadingProps {
  className?: string;
  full?: boolean;
  notFixed?: boolean;
  size?: number;
  transparent?: boolean;
}

export const LoadingWrapper = ({
  className = "",
  full = false,
  notFixed,
  size,
  transparent,
}: LoadingProps) => {
  const theme = useTheme();

  return (
    <div
      style={transparent ? { background: "none" } : {}}
      className={clsx("loading-container", className, {
        fixed: full || !notFixed,
        dark: theme === AppTheme.DARK,
      })}
    >
      <div className="loader" />

      <img
        className="logo"
        src={theme == AppTheme.DARK ? logoWhite : logo}
        alt="Loading"
      />
    </div>
  );
};
